import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-confirm-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'confirm-dialog.template.html'
})

export class ConfirmDialogComponent {

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public confirm() {
    this.dialogRef.close({confirm: true});
  }

  public cancel() {
    this.dialogRef.close({confirm: false});
  }
}
